import { render, staticRenderFns } from "./StartConversation.vue?vue&type=template&id=b4c1588e&scoped=true"
import script from "./StartConversation.vue?vue&type=script&lang=js"
export * from "./StartConversation.vue?vue&type=script&lang=js"
import style0 from "./StartConversation.vue?vue&type=style&index=0&id=b4c1588e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c1588e",
  null
  
)

export default component.exports